import React from 'react';
import { useSelector } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Icon
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import BoldTitle from './ContentTemplates/BoldTitle';
import ContentImage from './ContentTemplates/ContentImage';
import ContentTitle from './ContentTemplates/ContentTitle';
import ContentVideo from './ContentTemplates/ContentVideo';
import BoldStepsList from './ContentTemplates/BoldStepsList';
import ImportantText from './ContentTemplates/ImportantText';
import StepsList from './ContentTemplates/StepsList';
import GeneralText from './ContentTemplates/GeneralText';


const ListOfHelpArticles = () => {
  const history = useHistory();
  const {categoryUrl, subCategoryUrl, topicUrl} = useParams<{categoryUrl?: string; subCategoryUrl?: string; topicUrl?: string}>();
  const { helpTopics } = useSelector((state: IReduxState) => state.help);

  const handleChangeAccordionTab = (newTopicUrl) => {
    if (newTopicUrl === topicUrl) {
      history.push(`/help/${categoryUrl}/${subCategoryUrl}`);
    } else {
      history.push(`/help/${categoryUrl}/${subCategoryUrl}/${newTopicUrl}`);
    }
  };

  return (
    <div>
      {helpTopics.map((article) => (
        <Accordion
          key={article.title}
          elevation={25}
          className="mt-5 border-radius-6 w-full"
          expanded={article.path === topicUrl}
          onChange={() => handleChangeAccordionTab(article.path)}
        >
          <AccordionSummary
            expandIcon={<Icon>expand_more</Icon>}
          >
            <Typography variant="h5" className="text-brand m-2">{article.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="w-full">
              {article.content.map((el, idx) => (
                <div key={idx}>
                  {el.contentType === 'generalText' ? <GeneralText generalText={el.value} /> : ''}
                  {el.contentType === 'boldText' ? <BoldTitle boldTitle={el.value} /> : ''}
                  {el.contentType === 'image' ? <ContentImage imageSrc={el.value} itemIdx={idx} /> : ''}
                  {el.contentType === 'title' ? <ContentTitle title={el.value} /> : ''}
                  {el.contentType === 'video' ? <ContentVideo path={el.value} /> : ''}
                  {el.contentType === 'boldStepsList' ? <BoldStepsList stepsList={el.value} /> : ''}
                  {el.contentType === 'importantText' ? <ImportantText importantText={el.value} /> : ''}
                  {el.contentType === 'stepsList' ? <StepsList listOfSteps={el.value} /> : ''}
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default ListOfHelpArticles;
